import React from 'react'
import { useAppDispatch } from 'reduxTyped'
import { BtnV2, Icon, l } from '@manychat/manyui'

import { AiAutomationAnalytics } from 'apps/aiAutomation/lib/analytics'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAlwaysOnAutomationsActions } from 'apps/aiAutomation/store/core'
import { AiAutomationLayoutActions } from 'apps/aiAutomation/store/layout'
import { AiAutomationScenario } from 'shared/api/requests/aiAutomation/schemas'

import cm from './SuccessTuning.module.css'

export const SuccessTuning = () => {
  const dispatch = useAppDispatch()

  const openAutomationEditor = () => {
    dispatch(
      AiAutomationLayoutActions.currentViewReplaced({
        view: SidebarViewType.POSITIVE_COMMENT_REPLIES,
      }),
    )

    AiAutomationAnalytics.logAutomationEditorOpened({
      type: AiAutomationScenario.SOCIAL_ENGAGEMENT,
      source: 'tov_success_setup',
    })
  }

  const enableCommentReplies = async () => {
    openAutomationEditor()

    await dispatch(
      AiAlwaysOnAutomationsActions.updateScenarioStatus({
        scenario: AiAutomationScenario.SOCIAL_ENGAGEMENT,
        status: true,
      }),
    ).unwrap()

    AiAutomationAnalytics.logAutomationStatusChanged({
      type: AiAutomationScenario.SOCIAL_ENGAGEMENT,
      is_published: true,
      source: 'tov_success_setup',
    })
  }

  return (
    <div className={cm.successTuning}>
      <Icon.DoubleTick size={32} />

      <h2 className="m-t text-body font-semibold">
        {l.translate('Great! AI is ready to reply like you')}
      </h2>

      <p className="m-t-xxs text-secondary">
        {l.translate('Update or retrain your AI anytime in settings.')}
      </p>

      <BtnV2 onClick={enableCommentReplies} className="m-t-lg" variant="primary" fullWidth>
        {l.translate('Turn on Comment Replies')}
      </BtnV2>

      <BtnV2 onClick={openAutomationEditor} className="m-t-sm" variant="ghost-light" fullWidth>
        {l.translate('Maybe later')}
      </BtnV2>
    </div>
  )
}
